import { Component } from '@angular/core';
import { ICheckoutSession, ILineItem, IResponse } from '@interfaces/index';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { IProduct,  } from 'projects/ui-components/src/interfaces/IProduct';
import { HttpErrorResponse } from '@angular/common/http';
import { AppService } from '../services/app.service';
import { ProductService } from 'projects/assessments/src/app/services/product.service';
import { PaymentService } from 'projects/assessments/src/app/services/payment.service';


@Component({
  selector: 'app-b2c-assessment',
  templateUrl: './b2c-assessment.component.html',
  styleUrl: './b2c-assessment.component.scss'
})
export class B2cAssessmentComponent {

  form: FormGroup;
  products: IProduct[] = [];
  line_items: ILineItem[] = [];
  loading = false;
 
  constructor(
    protected _product_service: ProductService,
    protected _payment_service: PaymentService,
    protected _app_service: AppService,
    protected _fb: FormBuilder
  ) {
    this.form = this._fb.group({
      first_name: [null, Validators.required],
      last_name: [null, Validators.required],
      email_address: [null, Validators.required],
      org_name: [null],
    })
  }

  ngOnInit() {
    this.loading = true;
    this._product_service.getSpecialProduct().subscribe(
      (response: IResponse<IProduct[]>) => {
        this.products = response.data
        this.loading = false;
      },
      (response: HttpErrorResponse) => {
        this._app_service.notify(response.message, 'error')
        this.loading = false;
      }
    );
  }

  checkout() {
    this.line_items = this.products.map(
      (item: IProduct) => {
        return {
          id: item.id,
          quantity: item.qty ?? 1,
          price: item.default_price
        };
      }
    )
    
    this.createUserAndCheckout(this.line_items)
  }

  createUserAndCheckout(products: ILineItem[]) {
    this._payment_service.checkoutB2c(
      this.form.value.first_name,
      this.form.value.last_name,
      this.form.value.email_address,
      this.form.value.org_name,
      products).subscribe(
        (response: IResponse<ICheckoutSession>) => {
          window.location.href = response.data.url
        }
      )
  }

}
